import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';
import includes from 'lodash/includes';
import { CardHeader, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ArrowUpIcon from 'material-ui/svg-icons/navigation/arrow-upward';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import { database } from '../../utils/configureFirebase';
import csvConverter from '../../utils/CorporateCSV';
import EarlyBirdCorporateCard from '../../components/EarlyBirdCorporateCard';
import { theme } from '../../utils/getTheme';

const myanatomy = 'MA#CSV#PASSWORD';
const ContentWrapper = styled.div`
  width: 85%;
  margin: 0 auto;
`;

const ContentContainer = styled.div`
  margintop: 16px;
  & > * + * {
    margin-top: 16px;
  }
`;

const DataWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

const SearchWrpper = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  background-color: white;
  border-radius: 25px;
`;

const LoaderWrapper = styled.div`
  text-align: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const FloatingButtonContianer = styled.div`
  position: fixed;
  bottom: 12px;
  right: 12px;
  color: ${props => props.theme.primary1Color};
  transition: 0.3s ease-in-out;
`;

class EarlyBirdCorporate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      registerations: undefined,
      csvConfirmationModal: false,
      password: '',
      intervalId: 0,
      isLoading: true,
      passwordErrorText: undefined,
      searchText: '',
      filteredData: [],
      emptySearchOpen: false,
    };

    this.heading = undefined;
    this.headingNode = undefined;
  }

  componentDidMount() {
    this.registrationRef = database.ref('contact/corporate');
    this.registrationRef.on('value', this.setRegistrationData);
  }

  componentWillUnmount() {
    this.registrationRef.off('value', this.setRegistrationData);
  }

  setRegistrationData = (snapshot) => {
    if (snapshot) {
      const registrations = snapshot.val(); //---Stores all value
      this.setState({
        registrations,
        isLoading: false,
      });
    }
  };

  getRegistrations = (registrations) => {
    if (typeof registrations !== 'undefined') {
      const corporateArr = Object.keys(registrations).map((corporateId) => {
        const formattedData = this.formatRegistration(
          registrations[corporateId],
        );
        return {
          ...formattedData,
          corporateId,
        };
      });

      // console.log('Corporate data : ', orderBy(corporateArr, corporate => corporate.timestamp, 'desc'));
      return orderBy(corporateArr, corporate => corporate.timestamp, 'desc');
    }

    return [];
  };

  formatRegistration = data => ({
    ...data,
    // dob: formatDate(data.dob),
    certifications: data.certifications === '' ? '-' : data.certifications,
  });

  formattedDate = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}-${date.getHours()}:${date.getMinutes()}`;
  };

  openCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: true,
      passwordErrorText: undefined,
      password: '',
    }));
  };

  closeCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: false,
    }));
  };

  downloadCSV = (candidateRegistrations) => {
    const { password } = this.state;

    if (password === myanatomy) {
      csvConverter(candidateRegistrations, 'EB-Corprate');
      this.setState(() => ({
        csvConfirmationModal: false,
      }));
    } else {
      this.setState(() => ({
        passwordErrorText: 'PasswordMismatch',
      }));
    }
  };

  searchCorporate = (corporates) => {
    const { searchText } = this.state;
    this.setState(() => ({
      isLoading: true,
    }));
    const result = corporates.filter((corp) => {
      // eslint-disable-line
      if (includes(corp.companyName.toLowerCase(), searchText.toLowerCase())) {
        return corp;
      }
      return false;
    });
    if (result.length > 0) {
      this.setState(() => ({
        filteredData: result,
        isLoading: false,
      }));
    } else {
      this.setState(() => ({
        emptySearchOpen: true,
        searchText: '',
        isLoading: false,
        filteredData: [],
      }));
    }
  };

  resetSearch = () => {
    this.setState(() => ({
      searchText: '',
      filteredData: [],
    }));
  };

  moveToTop = () => {
    document
      .getElementById('headerDiv')
      .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
  };

  render() {
    const {
      registrations,
      password,
      passwordErrorText,
      csvConfirmationModal,
      isLoading,
      searchText,
      filteredData,
      emptySearchOpen,
    } = this.state;

    const { history } = this.props;
    const corporateRegisteration = this.getRegistrations(registrations);
    return (
      <div id="headerDiv">
        {isLoading ? (
          <ContentContainer>
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          </ContentContainer>
        ) : (
          <ContentWrapper>
            <FloatingButtonContianer>
              <FloatingActionButton mini>
                <ArrowUpIcon onTouchTap={this.moveToTop} />
              </FloatingActionButton>
            </FloatingButtonContianer>
            <DataWrapper>
              <CardHeader
                title={`Total Registerations: ${
                  filteredData.length === 0
                    ? corporateRegisteration.length
                    : filteredData.length
                }`}
                style={{ paddingLeft: 0, marginTop: '8px' }}
                textStyle={{ paddingRight: 0 }}
              />
              <SearchWrpper>
                <TextField
                  hintText="Search by Name or refrence Id"
                  value={searchText}
                  style={{ marginLeft: 16 }}
                  onChange={(_, value) => {
                    this.setState(() => ({
                      searchText: value,
                    }));
                  }}
                />
                {searchText !== '' ? (
                  <IconButton style={{ marginLeft: '-42px' }}>
                    <ClearIcon
                      color={theme.primary1Color}
                      onTouchTap={this.resetSearch}
                    />
                  </IconButton>
                ) : null}
                <IconButton>
                  <SearchIcon
                    style={{ height: 48, width: 30 }}
                    color={theme.primary1Color}
                    onTouchTap={() => {
                      this.searchCorporate(corporateRegisteration);
                    }}
                  />
                </IconButton>
              </SearchWrpper>

              <ButtonWrapper>
                <RaisedButton
                  primary
                  label="Download CSV"
                  onTouchTap={this.openCSVConfirmationModal}
                />
              </ButtonWrapper>
            </DataWrapper>
            {filteredData.length === 0 ? (
              <ContentContainer>
                {corporateRegisteration.map(corporate => (
                  <EarlyBirdCorporateCard
                    key={corporate.corporateId}
                    {...corporate}
                    history={history}
                  />
                ))}
              </ContentContainer>
            ) : (
              <ContentContainer>
                {filteredData.map(data => (
                  <EarlyBirdCorporateCard
                    key={data.corporateId}
                    {...data}
                    history={history}
                  />
                ))}
              </ContentContainer>
            )}
          </ContentWrapper>
        )}
        <Dialog
          title="Download"
          modal
          actions={[
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={this.closeCSVConfirmationModal}
            />,
            <RaisedButton
              label="Download"
              primary
              onTouchTap={() => {
                this.downloadCSV(corporateRegisteration);
              }}
            />,
          ]}
          onRequestClose={this.closeCSVConfirmationModal}
          open={csvConfirmationModal}
        >
          <CardText>
            <TextField
              floatingLabelText="Please Enter password to Download"
              type="password"
              value={password}
              onChange={(_, value) => {
                this.setState(() => ({
                  password: value,
                }));
              }}
              errorText={passwordErrorText}
            />
          </CardText>
        </Dialog>
        <Snackbar
          bodyStyle={{ backgroundColor: theme.primary1Color }}
          open={emptySearchOpen}
          message="No Result found"
          autoHideDuration={5000}
          onRequestClose={() => {
            this.setState(() => ({
              emptySearchOpen: false,
            }));
          }}
        />
      </div>
    );
  }
}

EarlyBirdCorporate.propTypes = {
  history: PropTypes.object.isRequired, // eslint-disable-line
};

export default EarlyBirdCorporate;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCorporate/EarlyBirdCorporate.js